module.exports = __webpack_public_path__ + "img/sport.c5335061.png";